var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "e-circular ecircular-detail" },
    [
      _c("TMSHeader", {
        attrs: {
          title: _vm.title,
          buttons: _vm.headerButtons,
          dotOption: _vm.dotOption,
          status: _vm.currentECircular.status,
          needGoback: true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("label", { staticClass: "title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("modified") + " " + _vm.$t("history")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "non-sticky-table" }, [
            _c("table", { staticClass: "non-sticky-table-header" }, [
              _c("thead", [
                _c(
                  "tr",
                  { staticClass: "sort-tr" },
                  _vm._l(_vm.historyTabelHead, function (value, index) {
                    return _c("th", { key: index }, [
                      _vm._v(
                        "\n              " + _vm._s(value) + "\n            "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.currentHistories, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c(
                      "td",
                      { staticClass: "ecircular-detail__th-summary" },
                      [
                        _vm.showSentResult(item)
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "eCircularHistorySummary",
                                    params: {
                                      id: _vm.ecircularId,
                                      hid: item.id,
                                    },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.sentCount(item) +
                                        "/" +
                                        item.sentTotal +
                                        " " +
                                        _vm.$t("action.sent")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("--")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "ecircular-detail__th-updator" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.updatorName) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "ecircular-detail__th-status" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("customStatusLabel")(item.status)) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "ecircular-detail__th-date" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.statusDate) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "ecircular-detail__th-remarks" },
                        [
                          !_vm.editingRemarks[item.id]
                            ? [
                                _c("pre", [
                                  _vm._v(
                                    _vm._s(_vm._f("isEmptyValue")(item.remarks))
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.canEditRemark
                                  ? _c("span", {
                                      staticClass: "fa fa-pencil icon pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.enableEditRemarks(item.id)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.remarks,
                                      expression: "item.remarks",
                                    },
                                    { name: "autosize", rawName: "v-autosize" },
                                    {
                                      name: "checkVisibility",
                                      rawName: "v-checkVisibility",
                                      value: { refresh: true },
                                      expression: "{refresh: true}",
                                    },
                                  ],
                                  staticClass: "autosize",
                                  attrs: { autofocus: "" },
                                  domProps: { value: item.remarks },
                                  on: {
                                    focusout: function ($event) {
                                      return _vm.updateRemarks(item)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "remarks",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("eCircular.detail"))),
          ]),
          _vm._v(" "),
          _c("CreateECircular", {
            ref: "eCircular-edit",
            attrs: { showHeader: false, canEdit: _vm.canEdit },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showAtResend
        ? _c("PreviewECircular", {
            ref: "resendPreviewECircular",
            attrs: { previewType: _vm.PREVIEW_TYPES.RESEND },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "ecircular-info-modal",
          staticClass: "ecircular-modal",
          attrs: {
            modalId: _vm.infoModalId,
            modalType: "small-modal",
            showCloseBtn: false,
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "modal-title",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "eCircular.chooseRecipients." + _vm.currentECircular.type
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("eCircular.setZoneMsg")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.closeModal("ecircular-info-modal")
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "ecircular-edit-modal",
          staticClass: "ecircular-modal",
          attrs: {
            modalId: _vm.editModalId,
            modalType: "small-modal",
            showCloseBtn: false,
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("eCircular.editECricularHint")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.closeModal("ecircular-edit-modal")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--darkblue",
                on: {
                  click: function ($event) {
                    return _vm.confirmEdit()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.yes")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("CancelECircular", { ref: "ecircular-cancel-modal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }